import { ofType } from 'redux-observable';
import { switchMap, mergeMap } from 'rxjs/operators';

import {
    freezeCard as freezeCardAction,
    freezeCardSuccess,
    freezeCardError,
    freezeCardReset,
    unfreezeCard as unfreezeCardAction,
    unfreezeCardSuccess,
    unfreezeCardError,
    unfreezeCardReset,
} from '@perpay-web/fintech/actions/ui/cardFreeze';
import {
    CARD_FREEZE_ENDPOINT,
    CARD_UNFREEZE_ENDPOINT,
} from '@perpay-web/fintech/constants/urls';
import { handleErrorMessageWithFallback } from '@perpay-web/observable/operators/handleErrorMessageWithFallback';

export const freezeCard = (action$, state$, { patch }) =>
    action$.pipe(
        ofType(freezeCardAction().type),
        switchMap((action) => {
            const { cardUuid } = action.payload;
            return patch(CARD_FREEZE_ENDPOINT.replace(':uuid', cardUuid));
        }),
        mergeMap(() => [
            freezeCardSuccess({ success: true }),
            unfreezeCardReset(),
        ]),
        handleErrorMessageWithFallback((error) => [freezeCardError(error)]),
    );

export const unfreezeCard = (action$, state$, { patch }) =>
    action$.pipe(
        ofType(unfreezeCardAction().type),
        switchMap((action) => {
            const { cardUuid } = action.payload;
            return patch(CARD_UNFREEZE_ENDPOINT.replace(':uuid', cardUuid));
        }),
        mergeMap(() => [
            unfreezeCardSuccess({ success: true }),
            freezeCardReset(),
        ]),
        handleErrorMessageWithFallback((error) => [unfreezeCardError(error)]),
    );
